import React from 'react';
import { motion } from 'framer-motion';
import { productById } from '../data/products';
import { ProductGlyph } from './ui/ProductGlyph';
interface ProductPanelProps {
  productId: string;
  accent: string;
  eyebrow?: string;
  companionId?: string;
}

/** The product only appears once the clinical need has been established. */
export function ProductPanel({
  productId,
  accent,
  eyebrow = 'Filtek solution',
  companionId
}: ProductPanelProps) {
  const product = productById(productId);
  const companion = companionId ? productById(companionId) : undefined;
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className="relative overflow-hidden border border-enamel/10 bg-enamel/[0.02] p-6 backdrop-blur-sm sm:p-8" data-id="element-109" data-mp="26fr11103rsqm">
      <div className="absolute inset-x-0 top-0 h-px" style={{
      backgroundColor: accent
    }} aria-hidden="true" data-id="element-110" data-mp="1wicubt3zeibi" />
      <div className="flex flex-col gap-7 sm:flex-row sm:items-start sm:gap-9" data-id="element-111" data-mp="kuihhf86clbg">
        <ProductGlyph form={product.form} accent={accent} className="h-32 w-16 shrink-0 sm:h-44 sm:w-20" data-id="element-112" data-mp="kwldqgzx7aom" />

        <div className="min-w-0 flex-1" data-id="element-113" data-mp="tufcdyl5qgey">
          <p className="label-mono text-[10px]" style={{
          color: accent
        }} data-id="element-114" data-mp="ttcidhsjfxut">
            {eyebrow}
          </p>
          <h4 className="mt-3 text-2xl font-light leading-tight tracking-[-0.02em] text-enamel sm:text-[1.85rem]" data-id="element-115" data-mp="24ai987lif0j">
            {product.name}
          </h4>
          <p className="mt-3 max-w-lg text-base font-light leading-relaxed text-mute" data-id="element-116" data-mp="3tbvhrundepz1">
            {product.claim}
          </p>

          <dl className="mt-7 grid gap-x-8 gap-y-4 sm:grid-cols-2" data-id="element-117" data-mp="ayp45tmmsnsm">
            {product.facts.map(fact => <div key={fact.label} className="border-t border-enamel/10 pt-3" data-id="element-118" data-mp="3elo4dtc7zx57">
                <dt className="label-mono text-[9px] text-mute/70" data-id="element-119" data-mp="3ejl50ip6grnt">{fact.label}</dt>
                <dd className="mt-1.5 text-sm font-light text-enamel" data-id="element-120" data-mp="3aju77v18hb9s">{fact.value}</dd>
              </div>)}
          </dl>

          {companion && <p className="mt-6 text-sm font-light text-mute" data-id="element-121" data-mp="1ihrhr3zfdl5f">
              Paired in the family with{' '}
              <span className="text-enamel" data-id="element-122" data-mp="1naaxo7ll4sde">{companion.name}</span> — {companion.descriptor}.
            </p>}
        </div>
      </div>
    </motion.div>;
}